export const PUSH_TEXT_TO_OUTLOOK_APP = 'pushTextToOutlookApp' as const;
export const PUSH_CSV_FILE_TO_OUTLOOK_APP = 'pushCsvFileToOutlookApp' as const;
export const APPROVAL = 'approval' as const;

interface ThreadStoreBase<T> {
  id: string;
  type: string;
  threadId: string;
  integrationId: string;
  flowId: string;
  data: T;
}

export interface PushTextToOutlookApp extends ThreadStoreBase<PushTextToOutlookAppData> {
  type: typeof PUSH_TEXT_TO_OUTLOOK_APP;
}

export interface PushCsvFileToOutlookApp extends ThreadStoreBase<PushCsvFileToOutlookAppData> {
  type: typeof PUSH_CSV_FILE_TO_OUTLOOK_APP;
}

export interface Approval extends ThreadStoreBase<ApprovalData> {
  type: typeof APPROVAL;
}

export interface PushTextToOutlookAppData {
  title: string;
  value?: string; // Backward compatibility with only one value to push
  values?: Record<string, string>; // label - value
}

export interface PushCsvFileToOutlookAppData {
  title: string;
  file: string;
  filename?: string;
  containsHeader: boolean;
}

export interface ApprovalData {
  approvalId: string;
  status: ApprovalStatus;
  valuesToApprove: Record<string, any>;
  approvedDate?: number;
  error?: 'ACTIONS_DISABLED_ERROR' | 'FLOW_REMOVED_ERROR' | 'FLOW_NOT_RUNNING_ERROR' | 'NO_THREAD_STORE';
}

export type ApprovalStatus = 'pending' | 'approved' | 'rejected' | 'failed';

export type ThreadStore = PushTextToOutlookApp | PushCsvFileToOutlookApp | Approval;
